import { Box } from "@mui/material";

const SkeletonBox = ({
  width = "100%",
  height = 20,
  mb = 2,
  rounded = true,
}) => (
  <Box
    sx={{
      width,
      height,
      mb,
      bgcolor: "grey.200",
      borderRadius: rounded ? 2 : 0,
      animation: "pulse 1.5s ease-in-out infinite",
      "@keyframes pulse": {
        "0%, 100%": { opacity: 1 },
        "50%": { opacity: 0.5 },
      },
    }}
  />
);

const CardSkeleton = () => (
  <Box
    sx={{
      p: 3,
      bgcolor: "white",
      borderRadius: 3,
      boxShadow: "0 4px 20px rgba(23, 19, 75, 0.08)",
      mb: 3,
    }}
  >
    <SkeletonBox width="60%" height={24} mb={2} />
    <SkeletonBox width="40%" height={20} mb={1} />
    <SkeletonBox width="80%" height={20} />
  </Box>
);

export default function PageSkeleton({ type = "default" }) {
  if (type === "card") {
    return (
      <Box>
        <SkeletonBox width="40%" height={32} mb={3} />
        {Array.from({ length: 3 }).map((_, i) => (
          <CardSkeleton key={i} />
        ))}
      </Box>
    );
  }

  if (type === "form") {
    return (
      <Box>
        <SkeletonBox width="30%" height={32} mb={4} />
        <Box sx={{ maxWidth: 600 }}>
          {Array.from({ length: 5 }).map((_, i) => (
            <Box key={i} sx={{ mb: 3 }}>
              <SkeletonBox width="25%" height={20} mb={1} />
              <SkeletonBox width="100%" height={48} mb={0} />
            </Box>
          ))}
        </Box>
      </Box>
    );
  }

  // Default skeleton
  return (
    <Box>
      <SkeletonBox width="40%" height={32} mb={3} />
      <SkeletonBox width="100%" height={200} mb={2} />
      <SkeletonBox width="100%" height={200} />
    </Box>
  );
}

